<td *ngIf="isSelectable" class="eui-u-color-grey-light eui-u-cursor-pointer">
    <eui-icon *ngIf="!isChecked" iconClass="eui-icon-checkbox-outline eui-u-font-size-2xl" euiSizeL (click)="toggleCheckedState(true)" aria-label="Check"></eui-icon>
    <eui-icon *ngIf="isChecked" euiPrimary iconClass="eui-icon-checkbox eui-u-font-size-2xl" euiSizeL (click)="toggleCheckedState(false)" aria-label="Uncheck"></eui-icon>
</td>
<ng-content></ng-content>
